import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import path from 'path';
import React, { useEffect, useMemo, useRef } from 'react';
import { createHashHistory } from 'history';
import { v4 as uuidV4 } from 'uuid';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Container, ListGroup, ListGroupItem, Row, Col, PopoverBody, UncontrolledPopover } from 'reactstrap';
import { checkPermission, makeResource } from '../../../behaviors/src/lib/permissions';
import { evaluateSource } from '../../../behaviors/src/lib/evaluateSource';
import entityComposition from '../common/classes/entityComposition';
import routeHelper from '../common/classes/routeHelper';
import ListPanel from '../common/containers/listPanel';
import CabinetActionsMenu from './cabinetActionsMenu';
import CabinetPagingTable from './cabinetPagingTable';
import CabinetFilterPanel from './cabinetFilterPanel';
import CabinetViewPicker from './cabinetViewPicker';
import CabinetRow from './cabinetRow';
import Map from '../editor/components/map/map';
import MapTypePicker from '../editor/components/map/mapTypePicker';
import Superset from '../superset/superset';
import contentChangeActionFactory from '../../actions/factories/contentChangeActionFactory';
import { configBehaviorsFunc } from '../../nativeBehaviors/configBehaviors';
import { getCabinetDeepLinkReplaceViewPayload, hasCabinetSavedViewDeepLink, shouldDeferBareCabinetIndexForDeepLink } from '../../utils/cabinetDeepLinkFilters';
import FavoriteButton from '../favorites/favoriteButton';
const hashHistory = createHashHistory();
const contentChangeActions = contentChangeActionFactory('form', 'forms');
const Cabinet = _ref => {
  var _indexQuery$filters, _indexQuery$filters$m, _indexQuery$filters2;
  let cabinet = _ref.cabinet,
    _ref$currentCabinetDe = _ref.currentCabinetDefinition,
    _ref$currentCabinetDe2 = _ref$currentCabinetDe === void 0 ? {
      loading: true
    } : _ref$currentCabinetDe,
    _ref$currentCabinetDe3 = _ref$currentCabinetDe2.actionsMenuItems,
    actionsMenuItems = _ref$currentCabinetDe3 === void 0 ? {} : _ref$currentCabinetDe3,
    _ref$currentCabinetDe4 = _ref$currentCabinetDe2.filterDefinitions,
    filterDefinitions = _ref$currentCabinetDe4 === void 0 ? [] : _ref$currentCabinetDe4,
    _ref$currentCabinetDe5 = _ref$currentCabinetDe2.formTypeIdentifiers,
    formTypeIdentifiers = _ref$currentCabinetDe5 === void 0 ? [] : _ref$currentCabinetDe5,
    _ref$currentCabinetDe6 = _ref$currentCabinetDe2.client,
    _ref$currentCabinetDe7 = _ref$currentCabinetDe6 === void 0 ? {} : _ref$currentCabinetDe6,
    _ref$currentCabinetDe8 = _ref$currentCabinetDe7.web,
    _ref$currentCabinetDe9 = _ref$currentCabinetDe8 === void 0 ? {} : _ref$currentCabinetDe8,
    aiSearch = _ref$currentCabinetDe9.aiSearch,
    _ref$currentCabinetDe0 = _ref$currentCabinetDe9.eventHandlers,
    eventHandlers = _ref$currentCabinetDe0 === void 0 ? {} : _ref$currentCabinetDe0,
    _ref$currentCabinetDe1 = _ref$currentCabinetDe9.layout,
    _ref$currentCabinetDe10 = _ref$currentCabinetDe1 === void 0 ? {} : _ref$currentCabinetDe1,
    superset = _ref$currentCabinetDe10.superset,
    _ref$currentCabinetDe11 = _ref$currentCabinetDe10.columns,
    columns = _ref$currentCabinetDe11 === void 0 ? [] : _ref$currentCabinetDe11,
    cabinetIdentifier = _ref$currentCabinetDe2.identifier,
    cabinetLoading = _ref$currentCabinetDe2.loading,
    searchPlaceholder = _ref$currentCabinetDe2.searchPlaceholder,
    title = _ref$currentCabinetDe2.title,
    cabinetActions = _ref.cabinetActions,
    formActions = _ref.formActions,
    formType = _ref.formType,
    formTypeActions = _ref.formTypeActions,
    location = _ref.location,
    _ref$login = _ref.login,
    _ref$login$user = _ref$login.user,
    permissions = _ref$login$user.permissions,
    mapboxToken = _ref$login$user.mapboxToken,
    user = _ref$login.user,
    _ref$views = _ref.views,
    views = _ref$views === void 0 ? ['List'] : _ref$views,
    urlCabinetIdentifier = _ref.match.params.cabinetIdentifier,
    info = _ref.notificationActions.info,
    _ref$favoritesEnabled = _ref.favoritesEnabled,
    favoritesEnabled = _ref$favoritesEnabled === void 0 ? false : _ref$favoritesEnabled,
    _ref$userSavedViews = _ref.userSavedViews,
    userSavedViews = _ref$userSavedViews === void 0 ? undefined : _ref$userSavedViews,
    _ref$userActions = _ref.userActions,
    _ref$userActions2 = _ref$userActions === void 0 ? {} : _ref$userActions,
    userServerShow = _ref$userActions2.serverShow;
  const currentCabinet = cabinet.currentCabinet,
    initialIndexQuery = cabinet.initialIndexQuery,
    updatedFormType = cabinet.updatedFormType,
    _cabinet$selectedView = cabinet.selectedView,
    selectedView = _cabinet$selectedView === void 0 ? {} : _cabinet$selectedView;
  const currentSelectedView = selectedView[cabinetIdentifier] || 'List';

  // set defaults for the cabinet-specific data since rendering happens while
  // server requests are being made
  const _ref2 = cabinet[urlCabinetIdentifier] || {},
    indexQuery = _ref2.indexQuery,
    _ref2$list = _ref2.list,
    list = _ref2$list === void 0 ? [] : _ref2$list,
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? false : _ref2$loading,
    _ref2$selected = _ref2.selected,
    selected = _ref2$selected === void 0 ? [] : _ref2$selected,
    _ref2$totalCount = _ref2.totalCount,
    totalCount = _ref2$totalCount === void 0 ? null : _ref2$totalCount;
  let columnTitles = columns.map(c => c.title || '');

  /** Per-route URL key already handed to `serverReplaceView` (same path as saved filters). */
  const deepLinkAppliedRef = useRef({
    cabinet: '',
    key: ''
  });
  /** Waiting for `indexQuery.initialized` before URL → `serverReplaceView`. */
  const pendingDeepLinkBaselineKeyRef = useRef('');
  /** Saved-views user fetch for saved-view deep link — once per mount. */
  const userSavedViewsLoadRequestedRef = useRef(false);
  const canCreate = useMemo(
  // check for allow_form_create on at least one form type.
  () => formTypeIdentifiers.some(ft => checkPermission(makeResource('form', ft), 'create', permissions, user)), [formTypeIdentifiers, permissions, user]);
  const sortMap = {};
  columns.forEach(c => {
    if (c.sortIndex) {
      sortMap[c.title] = c.sortIndex;
    }
  });

  // Admin user check for deleted forms feature - easy to modify later
  // To enable for all users, simply change this to: const isAdminUser = true;
  const isAdminUser = (user === null || user === void 0 ? void 0 : user.username) === 'truqc';
  // Build enhanced actions menu items that include Restore when appropriate
  const enhancedActionsMenuItems = useMemo(() => {
    const items = Array.isArray(actionsMenuItems) ? [...actionsMenuItems] : [];

    // Add Restore action for admin users (it will only show when metaDeleted === 1)
    if (isAdminUser) {
      const hasRestoreAction = items.some(item => {
        var _item$action;
        return ((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.type) === 'bulkUndelete';
      });
      if (!hasRestoreAction) {
        items.push({
          title: 'Restore',
          permission: 'allow_form_delete',
          // Same permission as delete
          icon: 'rotate-left',
          style: 'default',
          action: {
            type: 'bulkUndelete'
          }
        });
      }
    }
    return items;
  }, [actionsMenuItems, isAdminUser]);

  /**
   * Initial index loading. Deep links: parse in util, then `serverReplaceView` only (saved
   * filters route). Do not depend on the whole `cabinet` object — it changes every list tick
   * and would re-fire this effect endlessly.
   */
  useEffect(() => {
    if (cabinetLoading) {
      return;
    }
    if (hasCabinetSavedViewDeepLink(location) && !userSavedViews && user !== null && user !== void 0 && user.user_id && userServerShow && !userSavedViewsLoadRequestedRef.current) {
      userSavedViewsLoadRequestedRef.current = true;
      Promise.resolve(userServerShow(user.user_id)).catch(() => {});
    }
    if (shouldDeferBareCabinetIndexForDeepLink({
      location,
      filterDefinitions,
      currentCabinet,
      urlCabinetIdentifier,
      updatedFormType,
      formTypeIdentifiers
    })) {
      // `serverIndex` normally syncs `currentCabinet`; we skip bare index here, so sync
      // explicitly or deep-link `serverReplaceView` never runs (it requires a URL match).
      cabinetActions.setCurrentCabinet(urlCabinetIdentifier);
      return;
    }
    if (deepLinkAppliedRef.current.cabinet !== urlCabinetIdentifier) {
      deepLinkAppliedRef.current = {
        cabinet: urlCabinetIdentifier,
        key: ''
      };
      pendingDeepLinkBaselineKeyRef.current = '';
    }
    const _getCabinetDeepLinkRe = getCabinetDeepLinkReplaceViewPayload({
        location,
        filterDefinitions,
        initialIndexQuery,
        formTypeIdentifiers,
        cabinetIdentifier,
        savedViews: userSavedViews
      }),
      hasUrlFilters = _getCabinetDeepLinkRe.hasUrlFilters,
      replaceViewQuery = _getCabinetDeepLinkRe.replaceViewQuery,
      deepLinkKey = _getCabinetDeepLinkRe.deepLinkKey;
    const wantsDeepLinkApply = Boolean((formTypeIdentifiers === null || formTypeIdentifiers === void 0 ? void 0 : formTypeIdentifiers.length) && currentCabinet === urlCabinetIdentifier && hasUrlFilters && (replaceViewQuery || hasCabinetSavedViewDeepLink(location)));
    if (wantsDeepLinkApply) {
      const sliceInitialized = Boolean(indexQuery === null || indexQuery === void 0 ? void 0 : indexQuery.initialized);
      if (!sliceInitialized) {
        // While a forms index is in flight, `initialized` is often false on the pending query;
        // do not start another baseline or we loop dispatches and stall the UI.
        if (loading) {
          return;
        }
        if (pendingDeepLinkBaselineKeyRef.current !== deepLinkKey) {
          pendingDeepLinkBaselineKeyRef.current = deepLinkKey;
          cabinetActions.serverIndex(urlCabinetIdentifier, _objectSpread(_objectSpread({}, initialIndexQuery), {}, {
            filters: _objectSpread(_objectSpread({}, initialIndexQuery.filters || {}), {}, {
              formTypeIdentifiers,
              cabinetIdentifier
            }),
            initialized: false
          }));
        }
        return;
      }
      if (!replaceViewQuery) {
        return;
      }
      if (deepLinkAppliedRef.current.key === deepLinkKey) {
        return;
      }
      deepLinkAppliedRef.current.key = deepLinkKey;
      pendingDeepLinkBaselineKeyRef.current = '';
      cabinetActions.serverReplaceView(_objectSpread(_objectSpread({}, replaceViewQuery), {}, {
        initialized: false
      }));
      return;
    }
    pendingDeepLinkBaselineKeyRef.current = '';
    if (formTypeIdentifiers !== null && formTypeIdentifiers !== void 0 && formTypeIdentifiers.length && currentCabinet !== urlCabinetIdentifier || updatedFormType) {
      if (!(formTypeIdentifiers !== null && formTypeIdentifiers !== void 0 && formTypeIdentifiers.length)) return;
      let currentIndexQuery = indexQuery;
      if (!indexQuery) {
        currentIndexQuery = _objectSpread(_objectSpread({}, initialIndexQuery), {}, {
          filters: _objectSpread(_objectSpread({}, initialIndexQuery.filters || {}), {}, {
            formTypeIdentifiers,
            cabinetIdentifier
          })
        });
      } else {
        currentIndexQuery = _objectSpread(_objectSpread({}, indexQuery), {}, {
          filters: _objectSpread(_objectSpread({}, indexQuery.filters), {}, {
            formTypeIdentifiers,
            cabinetIdentifier
          })
        });
      }
      if (formTypeIdentifiers.includes(updatedFormType)) {
        currentIndexQuery.initialized = false;
      }
      cabinetActions.serverIndex(cabinetIdentifier, currentIndexQuery);
    }
  }, [cabinetActions, cabinetIdentifier, cabinetLoading, currentCabinet, filterDefinitions, formTypeIdentifiers, indexQuery, loading, initialIndexQuery, updatedFormType, urlCabinetIdentifier, location, userSavedViews, user === null || user === void 0 ? void 0 : user.user_id, userServerShow]);

  // load the form types
  useEffect(() => {
    formTypeActions.serverIndex(formType.indexQuery);
  }, [formType.indexQuery, formTypeActions]);
  const formTypesByIdentifier = useMemo(() => {
    const fts = {};
    formType.list.forEach(ft => {
      fts[ft.identifier] = ft;
    });
    return fts;
  }, [formType]);

  // If the cabinet finishes loading and there's no cabinetIdentifier redirect
  useEffect(() => {
    if (!cabinetLoading && cabinetIdentifier === 'unauthorized') {
      routeHelper.handleViewRedirect(false, location);
    }
  }, [cabinetIdentifier, cabinetLoading, location]);
  if (superset) {
    return /*#__PURE__*/React.createElement(Superset, {
      dashboardTitle: superset
    });
  }

  /**
   *  Add a new form after selecting a formType from the popover
   */
  const handleAdd = async formTypeIdentifier => {
    const createdDate = moment().utc().format('YYYY-MM-DD HH:mm:ss');
    const currentFormType = formTypesByIdentifier[formTypeIdentifier];
    const formID = uuidV4().toUpperCase();
    await formActions.create(formID, createdDate, user.user_id, currentFormType);
    await formActions.select(formID);
    const url = path.join('/cabinets', currentCabinet, formTypeIdentifier, formID);
    return hashHistory.push(url);
  };

  /**
   *  Execute onSelect behaviors when eventHandlers.onSelect is defined
   */
  const handleFormSelectBehaviors = async formID => {
    // find the clicked form in the list in order to grab its formType
    const form = list.find(f => f.id === formID);
    if (!form || !(form !== null && form !== void 0 && form.formTypeIdentifier)) return;
    const formTypeIdentifier = form.formTypeIdentifier;

    // set up the structures to call behaviors
    const nativeBehaviorEvaluator = contentChangeActions.getNativeBehaviorEvaluator();
    const evaluator = nativeBehaviorEvaluator.bind(null, {}, 'form');
    const nativeFunctions = {
      errorHandler: err => {
        info({
          headerMessage: 'Error',
          message: "An error occurred while processing the form selection: ".concat(err.message || 'Unknown error'),
          id: 'onSelect-behavior-error'
        });
      },
      evaluator,
      configBehaviors: configBehaviorsFunc
    };
    const transientContext = {
      cabinetIdentifier,
      uuid: formID,
      formTypeIdentifier
    };

    // execute each behavior in the onSelect array
    const onSelect = eventHandlers.onSelect;
    for (let i = 0; i < onSelect.length; i += 1) {
      const action = onSelect[i];
      // eslint-disable-next-line no-await-in-loop
      await evaluateSource(action, {}, '/', transientContext, nativeFunctions);
    }
  };

  /**
   *  Navigate to formEditor when row is clicked
   */
  const handleFormClick = async formID => {
    // find the clicked form in the list in order to grab its formType
    const form = list.find(f => f.id === formID);
    if (!form || !(form !== null && form !== void 0 && form.formTypeIdentifier)) return;
    const formTypeIdentifier = form.formTypeIdentifier;
    const canViewDetail = checkPermission(makeResource('form', formTypeIdentifier), 'view_detail', permissions, user);
    if (canViewDetail !== true) {
      info({
        headerMessage: 'Permissions',
        message: "You do not have permission to view the details of ".concat(form.formTypeIdentifier, "."),
        id: 'transition_while_resizing'
      });
      return;
    }

    // check if eventHandlers.onSelect is defined
    const hasOnSelect = Array.isArray(eventHandlers === null || eventHandlers === void 0 ? void 0 : eventHandlers.onSelect) && eventHandlers.onSelect.length > 0;
    if (hasOnSelect) {
      await handleFormSelectBehaviors(formID);
    } else {
      // default behavior: navigate to form detail view
      const url = path.join('/cabinets', currentCabinet, formTypeIdentifier, formID);
      hashHistory.push(url);
    }
  };

  /**
   *  Select a cabinet row
   */
  const handleSelect = (id, event) => {
    if (event.target.checked) {
      cabinetActions.select(id);
    } else {
      cabinetActions.selectClear(id);
    }
  };

  /**
   *  Select all cabinet rows
   */
  const handleSelectAll = event => {
    if (event && event.target.checked) {
      cabinetActions.selectAll(list.map(s => s.id));
    } else {
      cabinetActions.selectClearAll();
    }
  };
  const selectedFormTypeIdentifiers = formTypeIdentifiers.filter(ft => list.find(form => form.formTypeIdentifier === ft && selected.includes(form.id)));
  const creatableFormTypeIdentifiers = formTypeIdentifiers.filter(ft => checkPermission(makeResource('form', ft), 'create', permissions, user));
  let newFormPopover = null;
  let singleFormHandleAdd = null;
  if (creatableFormTypeIdentifiers.length > 1) {
    newFormPopover =
    /*#__PURE__*/
    // 'legacy' allows you to click button to show/hide and also click away to hide popover
    React.createElement(UncontrolledPopover, {
      trigger: "legacy",
      placement: "bottom",
      target: "t-button-new"
    }, /*#__PURE__*/React.createElement(PopoverBody, {
      style: {
        padding: 5,
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(ListGroup, {
      flush: true
    }, creatableFormTypeIdentifiers.map((identifier, index) => /*#__PURE__*/React.createElement(ListGroupItem, {
      key: identifier,
      role: "button",
      "data-testid": "t-c-new-form-".concat(identifier),
      tabIndex: index,
      onClick: () => handleAdd(identifier),
      onKeyUp: () => handleAdd(identifier)
    }, formTypesByIdentifier[identifier] ? formTypesByIdentifier[identifier].name : identifier)))));
  } else if (creatableFormTypeIdentifiers.length === 1) {
    singleFormHandleAdd = () => handleAdd(creatableFormTypeIdentifiers[0]);
  }

  // conditionally display the actions menu
  let showActionsMenu = false;
  if (enhancedActionsMenuItems.length > 0) {
    showActionsMenu = true;

    // add checkbox as the first column
    columnTitles = [/*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      "data-testid": "t-c-selectAll",
      onChange: handleSelectAll
    })].concat(columnTitles);
  }
  let listTitleAfter = null;
  const shouldShowCount = Boolean(indexQuery === null || indexQuery === void 0 || (_indexQuery$filters = indexQuery.filters) === null || _indexQuery$filters === void 0 || (_indexQuery$filters = _indexQuery$filters.formTypeIdentifiers) === null || _indexQuery$filters === void 0 ? void 0 : _indexQuery$filters.length);
  if (shouldShowCount) {
    if (typeof totalCount === 'number') {
      listTitleAfter = /*#__PURE__*/React.createElement("span", {
        "data-testid": "t-cabinet-total-count"
      }, ' ', "(", (totalCount !== null && totalCount !== void 0 ? totalCount : 0).toLocaleString(), ")");
    } else if (loading) {
      listTitleAfter = ' (...)';
    }
  }
  return /*#__PURE__*/React.createElement(Container, null, newFormPopover, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, views.length > 1 && mapboxToken && /*#__PURE__*/React.createElement(CabinetViewPicker, {
    cabinetIdentifier: cabinetIdentifier,
    selectedView: currentSelectedView,
    setSelectedView: cabinetActions.setSelectedView,
    views: views
  }), (currentSelectedView === 'Map' || currentSelectedView === 'Pipeline') && /*#__PURE__*/React.createElement(MapTypePicker, {
    cabinetIdentifier: cabinetIdentifier
  }), !currentCabinet ? '' : /*#__PURE__*/React.createElement(CabinetFilterPanel, {
    cabinetIdentifier: cabinetIdentifier,
    formTypeIdentifiers: formTypeIdentifiers,
    filterDefinitions: filterDefinitions,
    searchPlaceholder: searchPlaceholder,
    aiSearchConfig: aiSearch,
    username: user === null || user === void 0 ? void 0 : user.username
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(ListPanel, {
    actionButton: showActionsMenu ? /*#__PURE__*/React.createElement(CabinetActionsMenu, {
      actionsMenuItems: enhancedActionsMenuItems,
      availableFormTypeIdentifiers: formTypeIdentifiers,
      cabinetIdentifier: cabinetIdentifier,
      formTypeIdentifiers: formTypeIdentifiers,
      metaDeleted: (_indexQuery$filters$m = indexQuery === null || indexQuery === void 0 || (_indexQuery$filters2 = indexQuery.filters) === null || _indexQuery$filters2 === void 0 ? void 0 : _indexQuery$filters2.metaDeleted) !== null && _indexQuery$filters$m !== void 0 ? _indexQuery$filters$m : 0,
      onBulkAction: cabinetActions.bulkUpdate,
      permissions: permissions,
      selected: selected,
      selectedFormTypeIdentifiers: selectedFormTypeIdentifiers,
      user: user
    }) : null,
    favoriteButton: favoritesEnabled ? /*#__PURE__*/React.createElement(FavoriteButton, null) : null,
    title: title,
    titleAfter: listTitleAfter,
    showNew: canCreate,
    onAdd: singleFormHandleAdd
  }, currentSelectedView === 'List' ? /*#__PURE__*/React.createElement(CabinetPagingTable, {
    headers: columnTitles,
    loading: loading,
    indexQuery: indexQuery,
    attributeMap: sortMap
  }, list.map((row, index) => {
    var _indexQuery$filters3;
    return /*#__PURE__*/React.createElement(CabinetRow, {
      rowIndex: index,
      key: "cr-".concat(row.id),
      id: row.id,
      columns: columns,
      data: row,
      onClick: handleFormClick,
      hasActions: showActionsMenu,
      onSelect: (id, event) => handleSelect(id, event),
      isSelected: (selected || []).includes(row.id),
      isDeleted: (indexQuery === null || indexQuery === void 0 || (_indexQuery$filters3 = indexQuery.filters) === null || _indexQuery$filters3 === void 0 ? void 0 : _indexQuery$filters3.metaDeleted) === 1
    });
  })) : (currentSelectedView === 'Map' || currentSelectedView === 'Pipeline') && /*#__PURE__*/React.createElement(Map, {
    cabinetIdentifier: cabinetIdentifier,
    cabinetFilters: indexQuery === null || indexQuery === void 0 ? void 0 : indexQuery.filters,
    selectedView: currentSelectedView
  })))));
};
Cabinet.propTypes = {
  cabinet: PropTypes.shape({
    currentCabinet: PropTypes.string,
    initialIndexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    }),
    updatedFormType: PropTypes.string,
    selectedView: PropTypes.string
  }).isRequired,
  cabinetActions: PropTypes.shape({
    bulkUpdate: PropTypes.func,
    serverIndex: PropTypes.func,
    serverReplaceView: PropTypes.func,
    setCurrentCabinet: PropTypes.func,
    select: PropTypes.func,
    selectClear: PropTypes.func,
    selectAll: PropTypes.func,
    selectClearAll: PropTypes.func,
    setSelectedView: PropTypes.func
  }).isRequired,
  currentCabinetDefinition: PropTypes.shape({
    actionsMenuItems: PropTypes.arrayOf(PropTypes.shape({})),
    client: PropTypes.shape({
      web: PropTypes.shape({
        eventHandlers: PropTypes.shape({
          onSelect: PropTypes.arrayOf(PropTypes.shape({}))
        }),
        layout: PropTypes.shape({
          columns: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string
          }))
        })
      })
    }),
    filterDefinitions: PropTypes.arrayOf(PropTypes.shape({})),
    formTypeIdentifiers: PropTypes.arrayOf(PropTypes.string),
    sortDefinitions: PropTypes.arrayOf(PropTypes.shape({})),
    identifier: PropTypes.string,
    loading: PropTypes.bool,
    searchPlaceholder: PropTypes.string,
    title: PropTypes.string
  }),
  formActions: PropTypes.shape({
    create: PropTypes.func,
    select: PropTypes.func
  }).isRequired,
  formType: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  formTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string
  }).isRequired,
  views: PropTypes.arrayOf(PropTypes.string),
  match: PropTypes.shape({
    params: PropTypes.shape({
      cabinetIdentifier: PropTypes.string
    })
  }).isRequired,
  login: PropTypes.shape({
    user: PropTypes.shape({
      user_id: PropTypes.string,
      username: PropTypes.string,
      permissions: PropTypes.shape({
        formTypes: PropTypes.shape({})
      }),
      mapboxToken: PropTypes.string
    })
  }).isRequired,
  notificationActions: PropTypes.shape({
    info: PropTypes.func
  }).isRequired,
  favoritesEnabled: PropTypes.bool,
  userSavedViews: PropTypes.shape({}),
  userActions: PropTypes.shape({
    serverShow: PropTypes.func
  })
};
export { Cabinet as TestCabinet };
export default entityComposition(Cabinet, ['cabinet', 'formType', 'login', 'settings'], {
  // find the current cabinet definition from customerSettings based on the
  // cabinet identifier that's part of the URL
  currentCabinetDefinition: (state, props) => {
    var _state$settings;
    const cabinetIdentifier = props.match.params.cabinetIdentifier;
    const unauthorizedCabinet = {
      identifier: 'unauthorized'
    };
    if ((_state$settings = state.settings) !== null && _state$settings !== void 0 && _state$settings.loaded) {
      var _state$settings2;
      const cabinetDefinition = (_state$settings2 = state.settings) === null || _state$settings2 === void 0 || (_state$settings2 = _state$settings2.settings) === null || _state$settings2 === void 0 || (_state$settings2 = _state$settings2.cabinetDefinitions) === null || _state$settings2 === void 0 ? void 0 : _state$settings2.find(cd => cd.identifier === cabinetIdentifier);
      return cabinetDefinition ? _objectSpread(_objectSpread({}, cabinetDefinition), {}, {
        loading: false
      }) : _objectSpread(_objectSpread({}, unauthorizedCabinet), {}, {
        loading: false
      });
    }
    return _objectSpread(_objectSpread({}, unauthorizedCabinet), {}, {
      loading: true
    });
  },
  views: (state, props) => {
    var _props$match, _state$settings$setti, _cabinet$client;
    const cabinetIdentifier = (_props$match = props.match) === null || _props$match === void 0 || (_props$match = _props$match.params) === null || _props$match === void 0 ? void 0 : _props$match.cabinetIdentifier;
    const cabinet = (_state$settings$setti = state.settings.settings.cabinetDefinitions) === null || _state$settings$setti === void 0 ? void 0 : _state$settings$setti.find(cd => cd.identifier === cabinetIdentifier);
    // Return true if the "Map" view is present within the cabinet's views
    const cabinetViews = cabinet === null || cabinet === void 0 || (_cabinet$client = cabinet.client) === null || _cabinet$client === void 0 || (_cabinet$client = _cabinet$client.web) === null || _cabinet$client === void 0 || (_cabinet$client = _cabinet$client.views) === null || _cabinet$client === void 0 ? void 0 : _cabinet$client.map(view => view.title);
    return cabinetViews || ['List'];
  },
  favoritesEnabled: state => {
    var _state$settings3;
    return ((_state$settings3 = state.settings) === null || _state$settings3 === void 0 || (_state$settings3 = _state$settings3.settings) === null || _state$settings3 === void 0 ? void 0 : _state$settings3.favoritesEnabled) || false;
  },
  userSavedViews: state => {
    var _state$user;
    return (_state$user = state.user) === null || _state$user === void 0 || (_state$user = _state$user.active) === null || _state$user === void 0 || (_state$user = _state$user.content) === null || _state$user === void 0 ? void 0 : _state$user.savedViews;
  }
}, ['form', 'notification', 'user']);